import React from 'react';
import { FlagType } from '../../../../../../@types/product.enum';
import { useFlags } from '../../providers/FlagsProvider';
import { Title } from '../../../../../styled/Title';

const NewsTitle = () => {
  const flag = useFlags(FlagType.news);

  if (!flag) {
    return null;
  }

  return (
    <div>
      <Title
        title={flag.productBanner?.text ?? ''}
        textColor={flag.productBanner?.design.textColor}
      />
    </div>
  );
};

export default NewsTitle;
